import { render } from "./TinyMCE.vue?vue&type=template&id=0d874c3e"
import script from "./TinyMCE.vue?vue&type=script&lang=js"
export * from "./TinyMCE.vue?vue&type=script&lang=js"

import "./TinyMCE.vue?vue&type=style&index=0&id=0d874c3e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__